import './styles/style.css'
import Header from './components/Header'
import About from './components/About'
import Contact from './components/Contact'
import MarblingBackground from './components/MarblingBackground'
import { Analytics } from '@vercel/analytics/react'

function App() {
  return (
    <div className="app">
      <MarblingBackground />
      <div className="content-card">
        <a 
          href="https://www.madebymako.com/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="portfolio-arrow-button"
          aria-label="View Portfolio"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
        <Header />
        <main className="main-content">
          <About />
          <Contact />
        </main>
      </div>
      <Analytics />
    </div>
  )
}

export default App
